import { decodeQueryString, encodeQueryString } from '../../../../app/queryString'
import { SubMenuTabs } from '../../../components/SubMenu/SubMenuTabs'
import { QuoteSubview } from '../types'

export const FINANCIALS_SECTION_LABELS = {
  [QuoteSubview.Revenue]: 'Revenue',
  [QuoteSubview.Dividends]: 'Dividends',
  [QuoteSubview.Earnings]: 'Earnings',
  [QuoteSubview.Forecast]: 'Forecast',
}

const FINANCIAL_MENU_TABS: Array<keyof typeof FINANCIALS_SECTION_LABELS> = [
  QuoteSubview.Dividends,
  QuoteSubview.Earnings,
  QuoteSubview.Revenue,
  QuoteSubview.Forecast,
]

function getFinancialMenuTabs() {
  const searchParams = decodeQueryString()

  return FINANCIAL_MENU_TABS.map((value) => ({
    label: FINANCIALS_SECTION_LABELS[value],
    href: `/quote.ashx?${encodeQueryString({ ...searchParams, ty: value })}`,
    isActive: searchParams.ty === value,
    reloadDocument: true,
  }))
}

export function QuoteFinancialsTabMenu() {
  return <SubMenuTabs items={getFinancialMenuTabs()} />
}
